import { render, staticRenderFns } from "./paginationComponents.vue?vue&type=template&id=03cb94c2&scoped=true&"
import script from "./paginationComponents.vue?vue&type=script&lang=js&"
export * from "./paginationComponents.vue?vue&type=script&lang=js&"
import style0 from "./paginationComponents.vue?vue&type=style&index=0&id=03cb94c2&prod&scoped=true&lang=css&"
import style1 from "./paginationComponents.vue?vue&type=style&index=1&id=03cb94c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cb94c2",
  null
  
)

export default component.exports